import { AfterViewInit, Directive, DoCheck, ElementRef, inject, input, NgZone, OnDestroy } from "@angular/core";
import { BrowserType, UtilService } from "common/util.service";
import { fromEvent, Subject } from "rxjs";
import { auditTime, takeUntil } from "rxjs/operators";

@Directive({ selector: "[stagesAutoGrow]" })
export class AutoGrowDirective implements DoCheck, AfterViewInit, OnDestroy {
	private prevValue?: string;
	private elem = inject(ElementRef);
	private utilService = inject(UtilService);
	private _ngZone = inject(NgZone);

	_prevValue?: string;
	private readonly _destroyed = new Subject<void>();

	readonly minHeight = input<number>(52);

	readonly scrollHeightAddition = input<number>(10);

	constructor() {
		this.adjustHeight();
	}

	ngDoCheck(): void {
		if (this.elem.nativeElement.value === this.prevValue) {
			return;
		}
		this.adjustHeight();
	}

	ngAfterViewInit(): void {
		this.adjustHeight();
		if (this._ngZone) {
			this._ngZone.runOutsideAngular(() => {
				fromEvent(window, "resize")
					.pipe(auditTime(16), takeUntil(this._destroyed))
					.subscribe(() => this.adjustHeight());
			});
		}
	}

	ngOnDestroy(): void {
		this._destroyed.next();
		this._destroyed.complete();
	}

	adjustHeight(): void {
		const textarea: HTMLTextAreaElement = this.elem.nativeElement;
		const scrollY = this.getScrollY();
		textarea.style.height = "0px";

		const height = textarea.scrollHeight + this.scrollHeightAddition();
		const newHeight = height < this.minHeight() ? this.minHeight() : height;
		this.prevValue = textarea.value;

		textarea.style.height = `${newHeight}px`;
		window.scroll(0, scrollY);
	}

	getScrollY(): number {
		switch (this.utilService.getBrowserType()) {
			case BrowserType.Chromium:
			case BrowserType.Edge: {
				return window.scrollY;
			}
			case BrowserType.Firefox:
			case BrowserType.Safari: {
				return window.pageYOffset;
			}
			case BrowserType.IE: {
				return document.body.scrollTop;
			}
			default: {
				return 0;
			}
		}
	}
}
